export function useCacheProviderAPI() {
  const { errors, request } = useRequest();

  async function fetchAccountSettings(requestBody: readonly (keyof AccountSettings)[]) {
    const url = versionedUrl('AccountSettings/ById');
    const requestOptions: RequestOptions = {
      method: 'post',
      body: requestBody
    };

    return await request<AccountSetting[]>(url, requestOptions);
  }

  return {
    errors,
    fetchAccountSettings
  };
}
